import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import ProductoForm from "./ProductoForm";

const ProductoEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/producto/' + id, {});

  const onUpdate = (prod) => {
    prod.id = id;
    axios.put(Apis.PROD + '/producto/update/' + id, prod)
      .then(res => {
        successToast("Producto actualizado correctamente")
        navigate('/productos')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Productos' onClick={() => navigate('/productos')}/>
        <PageTitle title={data.nombre}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <ProductoForm value={data} onSubmit={(prod) => onUpdate(prod)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default ProductoEdit;
